export const ESC = 'Escape';
export const ENTER = 'Enter';
